import React from 'react';
import { Center, HStack, Box, Circle, Avatar, Pressable, useTheme } from 'native-base';
import TopicReplyForm from './TopicReplyForm';
import { useAuthState } from '../../../../context/auth';
import { useEnvState } from '../../../../context/env';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faUser } from '@fortawesome/pro-solid-svg-icons';
import IconShield from '../reusables/IconShield';
const CreateEditButton = _ref => {
  let {
    isTypeTopic,
    edit,
    type,
    topic,
    reply,
    handleTopicReply,
    navigation,
    startNewTopicButtonRef,
    showUserProfile,
    onCloseHandler
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const isEditMode = edit;
  const envState = useEnvState();
  const authState = useAuthState();
  const userAvatar = authState.auth_user_avatar;
  const basicUserAvatar = /*#__PURE__*/React.createElement(Circle, {
    size: '36px',
    bg: 'secondary.400'
  }, userAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    source: {
      uri: userAvatar
    },
    size: 9
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUser,
    color: colors.createEditButton.avatar.icon,
    size: 6
  }));
  const userAvatarImage = authState.moderator ?
  /*#__PURE__*/
  /* Would be much simpler to use Avatar.Badge above, but I can't figure out
     how to get a width and height of 0 to be passed down so the default circle doesn't show up
     what we have works so I'm not going to waste my time further trying to get it working
     NOT WORKING: <Avatar.Badge bg="white" w="0px" height="0px">
   */
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Circle, {
    size: 10,
    borderColor: colors.createEditButton.avatar.highlight,
    borderWidth: 2
  }, basicUserAvatar), /*#__PURE__*/React.createElement(IconShield, {
    right: -2
  })) : basicUserAvatar;
  const TopicButton = /*#__PURE__*/React.createElement(Box, {
    width: '100%',
    bg: {
      base: colors.createEditButton.container.bg,
      lg: 'none'
    },
    py: 3
  }, /*#__PURE__*/React.createElement(HStack, {
    bg: colors.createEditButton.bg,
    px: 4,
    py: 3,
    borderColor: colors.topic.createButton.border,
    borderTopWidth: {
      base: 1,
      lg: 0
    },
    borderBottomWidth: {
      base: 1,
      lg: 0
    }
  }, /*#__PURE__*/React.createElement(Pressable, {
    mr: 3,
    onPress: () => showUserProfile({
      username: `${envState.discourse_api_username_prefix}.${authState.platform_user_id}`,
      avatar_template: userAvatar
    })
  }, userAvatarImage), /*#__PURE__*/React.createElement(Box, {
    flex: 1
  }, /*#__PURE__*/React.createElement(TopicReplyForm, {
    handleTopicReply: handleTopicReply,
    forceTypeTopic: true,
    newTopicButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    startNewTopicButtonRef: startNewTopicButtonRef,
    onCloseHandler: onCloseHandler
  }))));
  const ReplyButton = /*#__PURE__*/React.createElement(Center, null, /*#__PURE__*/React.createElement(TopicReplyForm, {
    handleTopicReply: handleTopicReply,
    newReplyButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    onCloseHandler: onCloseHandler
  }));
  const EditButton = /*#__PURE__*/React.createElement(TopicReplyForm, {
    handleTopicReply: handleTopicReply,
    edit: true,
    editButton: true,
    type: type,
    topic: topic,
    reply: reply,
    isTypeTopic: isTypeTopic,
    onCloseHandler: onCloseHandler
  });
  if (!isEditMode) {
    if (isTypeTopic) {
      return TopicButton;
    }
    return ReplyButton;
  }
  return EditButton;
};
export default CreateEditButton;
//# sourceMappingURL=CreateEditButton.js.map